import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminActivity } from "@/components/admin/AdminActivity";
import { AdminStats } from "@/components/admin/AdminStats";
import { AdminUsers } from "@/components/admin/AdminUsers";
import { AdminReports } from "@/components/admin/AdminReports";
import { AdminVerify } from "@/components/admin/AdminVerify";
import { AdminRelist } from "@/components/admin/AdminRelist";
import { AdminSupport } from "@/components/admin/AdminSupport";
import { AdminDeletions } from "@/components/admin/AdminDeletions";
import { AdminBroadcast } from "@/components/admin/AdminBroadcast";

function hasPerm(user, ...perms) {
  if (user?.is_super_admin) return true;
  const granted = user?.admin_perms || [];
  return perms.some((p) => granted.includes(p));
}

export default function Admin() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const focusUser = params.get("user");

  const tabs = [
    { k: "activity", label: "Activity", show: true, render: () => <AdminActivity /> },
    { k: "stats", label: "Stats", show: hasPerm(user, "stats"), render: () => <AdminStats /> },
    { k: "users", label: "Users", show: hasPerm(user, "users"), render: () => <AdminUsers focusUser={focusUser} /> },
    { k: "deletions", label: "Deletions", show: hasPerm(user, "users"), render: () => <AdminDeletions /> },
    { k: "reports", label: "Reports", show: hasPerm(user, "reports", "listings"), render: () => <AdminReports /> },
    { k: "verify", label: "Verify", show: hasPerm(user, "verify"), render: () => <AdminVerify /> },
    { k: "relist", label: "Relist", show: hasPerm(user, "relist"), render: () => <AdminRelist /> },
    { k: "support", label: "Support", show: hasPerm(user, "support"), render: () => <AdminSupport /> },
    { k: "broadcast", label: "Broadcast", show: !!user?.is_super_admin, render: () => <AdminBroadcast /> },
  ].filter((t) => t.show);

  const [tab, setTab] = useState(focusUser ? "users" : "activity");
  const current = tabs.find((t) => t.k === tab) || tabs[0];

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-extrabold">Admin panel</h1>
      <p className="text-sm text-muted-foreground">Manage Venda Market — {user?.is_super_admin ? "Super admin" : "Admin"}</p>

      <div className="mt-4 flex gap-1 overflow-x-auto border-b border-border">
        {tabs.map((t) => (
          <button
            key={t.k}
            data-testid={`admin-tab-${t.k}`}
            onClick={() => setTab(t.k)}
            className={`-mb-px whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-semibold ${tab === t.k ? "border-price text-price" : "border-transparent text-muted-foreground hover:text-foreground"}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-6">{current?.render()}</div>
    </div>
  );
}
